//imports
import { HashRouter,Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import PasswordEdit from './pages/profile/PasswordEdit';
import Settings from './pages/settings/Settings';
import Users from './pages/users/Users';
import UserCreate from './pages/users/UserCreate';
import UserEdit from './pages/users/UserEdit';

import Subscribe from './pages/Subscribe';
import OtpConfirm from './pages/OtpConfirm';
import Topups from './pages/topups/Topups'; 
import TopupCreate from './pages/topups/TopupCreate';
import Play from './pages/play/Play';
import PlayCreate from './pages/play/PlayCreate';
import ErrorBoundary from './components/ErrorBoundary';
import Transactions from './pages/transactions/Transactions';
import Client from './pages/clients/Client';
import ClientCreate from './pages/clients/ClientCreate';
import ClientEdit from './pages/clients/ClientEdit';
import ServiceType from './pages/serviceType/ServiceType';
import ServiceTypeCreate from './pages/serviceType/ServiceTypeCreate';
import ServiceTypeEdit from './pages/serviceType/ServiceTypeEdit';
import SdpService from './pages/sdpService/SdpService';
import SdpServiceCreate from './pages/sdpService/SdpServiceCreate';
import SdpServiceEdit from './pages/sdpService/SdpServiceEdit';
import AppUsers from './pages/appUsers/AppUsers';
import AppUserCreate from './pages/appUsers/AppUserCreate';
import AppUserEdit from './pages/appUsers/AppUserEdit';
import Deposit from './pages/deposit/Deposit';
import DepositCreate from './pages/deposit/DepositCreate';
import DepositEdit from './pages/deposit/DepositEdit';
import Winning from './pages/winning/Winning';
import WinningCreate from './pages/winning/WinningCreate';
import WinningEdit from './pages/winning/WinningEdit';
import InteractiveSms from './pages/interactiveSms/InteractiveSms';
import SmsMessage from './pages/smsMessage/SmsMessage';
import DailyUsers from './pages/dailyUsers/DailyUsers';
import SmsMessageCreate from './pages/smsMessage/SmsMessageCreate';
import Phonebook from './pages/phonebook/Phonebook';
import PhonebookCreate from './pages/phonebook/PhonebookCreate';
import PhonebookEdit from './pages/phonebook/PhonebookEdit';
import Phonebookupload from './pages/phonebookupload/Phonebookupload';
import PhonebookuploadCreate from './pages/phonebookupload/PhonebookuploadCreate';
import PhonebookuploadEdit from './pages/phonebookupload/PhonebookuploadEdit';
import Bulkbroadcast from './pages/bulkbroadcast/Bulkbroadcast';
import BulkbroadcastCreate from './pages/bulkbroadcast/BulkbroadcastCreate';
import BulkbroadcastEdit from './pages/bulkbroadcast/BulkbroadcastEdit';
import Senderid from './pages/senderid/Senderid';
import SenderidCreate from './pages/senderid/SenderidCreate';
import SenderidEdit from './pages/senderid/SenderidEdit';     
import SubscriptionSchedule from './pages/subscriptionSchedule/SubscriptionSchedule';
import SubscriptionScheduleCreate from './pages/subscriptionSchedule/SubscriptionScheduleCreate';
import SubscriptionScheduleEdit from './pages/subscriptionSchedule/SubscriptionScheduleEdit';
import Daysale from './pages/daysale/Daysale';
import DaysaleCreate from './pages/daysale/DaysaleCreate';
import DaysaleEdit from './pages/daysale/DaysaleEdit';
import InitiatePayment from './pages/initiatePayment/InitiatePayment';
import InitiatePaymentCreate from './pages/initiatePayment/InitiatePaymentCreate';
import InitiatePaymentEdit from './pages/initiatePayment/InitiatePaymentEdit';
import Product from './pages/product/Product';
import ProductCreate from './pages/product/ProductCreate';
import ProductEdit from './pages/product/ProductEdit';
import ClientInvoice from './pages/clientInvoice/ClientInvoice';
import ClientInvoiceCreate from './pages/clientInvoice/ClientInvoiceCreate';
import ClientInvoiceEdit from './pages/clientInvoice/ClientInvoiceEdit';
import CreateInvoice from './pages/clientInvoice/CreateInvoice';
import PrnRequest from './pages/prnRequest/PrnRequest';
import PrnRequestCreate from './pages/prnRequest/PrnRequestCreate';
import PrnRequestEdit from './pages/prnRequest/PrnRequestEdit';
import PaymentRequest from './pages/paymentRequest/PaymentRequest';
import PaymentRequestCreate from './pages/paymentRequest/PaymentRequestCreate';
import PaymentRequestEdit from './pages/paymentRequest/PaymentRequestEdit';
import Taxpayoutresponse from './pages/taxpayoutresponse/Taxpayoutresponse';
import TaxpayoutresponseCreate from './pages/taxpayoutresponse/TaxpayoutresponseCreate';
import TaxpayoutresponseEdit from './pages/taxpayoutresponse/TaxpayoutresponseEdit';
import WithdrawalRequest from './pages/withdrawalRequest/WithdrawalRequest';
import WithdrawalRequestCreate from './pages/withdrawalRequest/WithdrawalRequestCreate';
import WithdrawalRequestEdit from './pages/withdrawalRequest/WithdrawalRequestEdit';

import StkPushRequest from './pages/stkPushRequest/StkPushRequest';
import StkPushRequestCreate from './pages/stkPushRequest/StkPushRequestCreate';
import StkPushRequestEdit from './pages/stkPushRequest/StkPushRequestEdit';
import ReceiveBulkStakes from './pages/receiveBulkStakes/ReceiveBulkStakes';
import ReceiveBulkStakeCreate from './pages/receiveBulkStakes/ReceiveBulkStakeCreate';
import ReceiveBulkStakeEdit from './pages/receiveBulkStakes/ReceiveBulkStakeEdit';
import Outcomeinfologs from './pages/outcomeinfologs/Outcomeinfologs';
import OutcomeinfologCreate from './pages/outcomeinfologs/OutcomeinfologCreate';
import OutcomeinfologEdit from './pages/outcomeinfologs/OutcomeinfologEdit';

import Dailytaxobligation from './pages/dailytaxobligation/Dailytaxobligation';
import DailytaxobligationCreate from './pages/dailytaxobligation/DailytaxobligationCreate';
import DailytaxobligationEdit from './pages/dailytaxobligation/DailytaxobligationEdit';

import Player from './pages/player/Player';
import PlayerCreate from './pages/player/PlayerCreate';
import PlayerEdit from './pages/player/PlayerEdit';


function App(){
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    <Route path="/login" element={<Login />}/>
                    <Route path="/changePassword" element={<PasswordEdit />}/>
                    <Route path="/otpConfirm" element={<OtpConfirm />}/>
                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/" element={<Dashboard />}/>
                    <Route path="/topups" element={<Topups />}/>
                    <Route path="/topupCreate" element={<TopupCreate />}/>
                    <Route path="/play" element={<Play />}/>
                    <Route path="/playCreate" element={<PlayCreate />}/>
                    <Route path="/transactions" element={<Transactions />}/>
                    <Route path="/client" element={<Client />}/>
                    <Route path="/clientCreate" element={<ClientCreate />}/>
                    <Route path={`/client/:id/edit`} element={<ClientEdit />}/>
                    <Route path="/serviceType" element={<ServiceType />}/>
                    <Route path="/serviceTypeCreate" element={<ServiceTypeCreate />}/>
                    <Route path={`/serviceType/:id/edit`} element={<ServiceTypeEdit />}/>
                    <Route path="/sdpService" element={<SdpService />}/>
                    <Route path="/sdpServiceCreate" element={<SdpServiceCreate />}/>
                    <Route path={`/sdpService/:id/edit`} element={<SdpServiceEdit />}/>
                    <Route path="/appUsers" element={<AppUsers />}/>
                    <Route path="/dailyUsers" element={<DailyUsers />}/>
                    <Route path="/appUserCreate" element={<AppUserCreate />}/>
                    <Route path={`/appUser/:id/edit`} element={<AppUserEdit />}/>
                    <Route path="/deposit" element={<Deposit />}/>
                    <Route path="/depositCreate" element={<DepositCreate />}/>
                    <Route path={`/deposit/:id/edit`} element={<DepositEdit />}/>
                    <Route path="/winning" element={<Winning />}/>
                    <Route path="/winningCreate" element={<WinningCreate />}/>
                    <Route path={`/winning/:id/edit`} element={<WinningEdit />}/>
                    <Route path="/interactiveSms" element={<InteractiveSms />}/>
                    <Route path="/smsMessage" element={<SmsMessage />}/>
                    <Route path="/smsMessageCreate" element={<SmsMessageCreate />}/>
                    <Route path="/phonebook" element={<Phonebook />}/>
                    <Route path="/phonebookCreate" element={<PhonebookCreate />}/>
                    <Route path={`/phonebook/:id/edit`} element={<PhonebookEdit />}/>
                    <Route path="/phonebookupload" element={<Phonebookupload />}/>
                    <Route path="/phonebookuploadCreate" element={<PhonebookuploadCreate />}/>
                    <Route path={`/phonebookupload/:id/edit`} element={<PhonebookuploadEdit />}/>
                    <Route path="/bulkbroadcast" element={<Bulkbroadcast />}/>
                    <Route path="/bulkbroadcastCreate" element={<BulkbroadcastCreate />}/>
                    <Route path={`/bulkbroadcast/:id/edit`} element={<BulkbroadcastEdit />}/>
                    <Route path="/senderid" element={<Senderid />}/>
                    <Route path="/senderidCreate" element={<SenderidCreate />}/>
                    <Route path={`/senderid/:id/edit`} element={<SenderidEdit />}/>
                    <Route path="/subscriptionSchedule" element={<SubscriptionSchedule />}/>
                    <Route path="/subscriptionScheduleCreate" element={<SubscriptionScheduleCreate />}/>
                    <Route path={`/subscriptionSchedule/:id/edit`} element={<SubscriptionScheduleEdit />}/>
                    <Route path="/daysale" element={<Daysale />}/>
                    <Route path="/daysaleCreate" element={<DaysaleCreate />}/>
                    <Route path={`/daysale/:id/edit`} element={<DaysaleEdit />}/>
                    <Route path="/initiatePayment" element={<InitiatePayment />}/>
                    <Route path="/initiatePaymentCreate" element={<InitiatePaymentCreate />}/>
                    <Route path={`/initiatePayment/:id/edit`} element={<InitiatePaymentEdit />}/>
                    <Route path="/product" element={<Product />}/>
                    <Route path="/productCreate" element={<ProductCreate />}/>
                    <Route path={`/product/:id/edit`} element={<ProductEdit />}/>
                    <Route path="/clientInvoice" element={<ClientInvoice />}/>
                    <Route path="/clientInvoiceCreate" element={<ClientInvoiceCreate />}/>
                    <Route path={`/clientInvoice/:id/edit`} element={<ClientInvoiceEdit />}/>
                    <Route path={`/createInvoice/:id/pdf`} element={<CreateInvoice />}/>
                    <Route path="/settings" element={<Settings />}/>
                    <Route path="/users" element={<Users />}/>
                    <Route path="/userCreate" element={<UserCreate />}/>
                    <Route path={`/user/:id/edit`} element={<UserEdit />}/>

                    <Route path="/prnRequest" element={<PrnRequest />}/>
                    <Route path="/prnRequestCreate" element={<PrnRequestCreate />}/>
                    <Route path={`/prnRequest/:id/edit`} element={<PrnRequestEdit />}/>

                    <Route path="/paymentRequest" element={<PaymentRequest />}/>
                    <Route path="/paymentRequestCreate" element={<PaymentRequestCreate />}/>
                    <Route path={`/paymentRequest/:id/edit`} element={<PaymentRequestEdit />}/>
                    <Route path="/taxpayoutresponse" element={<Taxpayoutresponse />}/>
                    <Route path="/taxpayoutresponseCreate" element={<TaxpayoutresponseCreate />}/>
                    <Route path={`/taxpayoutresponse/:id/edit`} element={<TaxpayoutresponseEdit />}/>
                    <Route path="/withdrawalRequest" element={<WithdrawalRequest />}/>
                    <Route path="/withdrawalRequestCreate" element={<WithdrawalRequestCreate />}/>
                    <Route path={`/withdrawalRequest/:id/edit`} element={<WithdrawalRequestEdit />}/>

                    <Route path="/stkPushRequest" element={<StkPushRequest />}/>
                     <Route path="/stkPushRequestCreate" element={<StkPushRequestCreate />}/>
                     <Route path={`/stkPushRequest/:id/edit`} element={<StkPushRequestEdit />}/>

                     <Route path="/receiveBulkStakes" element={<ReceiveBulkStakes />}/>
                     <Route path="/receiveBulkStakeCreate" element={<ReceiveBulkStakeCreate />}/>
                     <Route path={`/receiveBulkStake/:id/edit`} element={<ReceiveBulkStakeEdit />}/>
                     
                     <Route path="/outcomeinfologs" element={<Outcomeinfologs />}/>
                     <Route path="/outcomeinfologCreate" element={<OutcomeinfologCreate />}/>
                     <Route path={`/outcomeinfolog/:id/edit`} element={<OutcomeinfologEdit />}/>

                    <Route path="/dailytaxobligation" element={<Dailytaxobligation />}/>
                     <Route path="/dailytaxobligationCreate" element={<DailytaxobligationCreate />}/>
                     <Route path={`/dailytaxobligation/:id/edit`} element={<DailytaxobligationEdit />}/>
                      <Route path="/player" element={<Player />}/>
                     <Route path="/playerCreate" element={<PlayerCreate />}/>
                     <Route path={`/player/:id/edit`} element={<PlayerEdit />}/>
                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;